@if(form && question) {
  <ls-fields-base [form]="form" [question]="question">
    <ng-container [formGroup]="form">
      <ng-template #viewContainerRef></ng-template>
    </ng-container>
  </ls-fields-base>
}
